// extracted by mini-css-extract-plugin
export var bubble = "_11-0";
export var container = "_11-f";
export var contrastBorder = "_11-g";
export var greyOut = "_11-2";
export var initialsColor0 = "_11-3";
export var initialsColor1 = "_11-4";
export var initialsColor10 = "_11-d";
export var initialsColor11 = "_11-e";
export var initialsColor2 = "_11-5";
export var initialsColor3 = "_11-6";
export var initialsColor4 = "_11-7";
export var initialsColor5 = "_11-8";
export var initialsColor6 = "_11-9";
export var initialsColor7 = "_11-a";
export var initialsColor8 = "_11-b";
export var initialsColor9 = "_11-c";
export var initialsWrapper = "_11-1";
export var large = "_11-l";
export var medium = "_11-k";
export var mediumSmall = "_11-j";
export var mediumSmallMedium = "_11-o";
export var micro = "_11-h";
export var small = "_11-i";
export var tiny = "_11-n";
export var xTiny = "_11-m";